import { Injectable } from '@angular/core';
import { Actions, getActionTypeFromInstance } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ActionStatus } from '@ngxs/store/src/actions-stream';
import { ErrorAction } from '@nimbus-library/features/shared/ngxs/error-action.model';
import { ILogger } from '../logger/i-logger';

@Injectable({ providedIn: 'root' })
export class NgxsStateLoggerService {
  private readonly subscription$ = new Subscription();

  public constructor(
    private readonly actions$: Actions,
    private readonly logger: ILogger,
  ) {}

  public startListening() {
    this.subscription$.add(
      this.actions$.subscribe((data: any) => {
        try {
          const type = getActionTypeFromInstance(data.action);
          const status = data.status;
          const action = data.action;

          if (action instanceof ErrorAction && status === ActionStatus.Dispatched) {
            // Fail or Error Action handled exception
            this.logActionError(type, action, action.parentActionId);
          }

          if (status === ActionStatus.Errored) {
            // Unhandled exception in Action Handler
            this.logActionError(type, data);
          }
        } catch (err) {
          this.logger.error(err);
        }
      }),
    );
  }

  private logActionError(actionId: string, data: any, parentAction?: string) {
    const optionalParam = { action: actionId, parentAction, source: 'redux' };
    if (data.error) {
      const error = data.error;
      if (error instanceof Error) {
        this.logger.exception(error, optionalParam);
      } else {
        this.logger.error(error, [optionalParam]);
      }
    }
  }

  public stopListening() {
    this.subscription$.unsubscribe();
  }
}
